import {APP_CONFIG} from "../../config/GeneralConfig";
import {UserViewSettings, UserViewSettingsProp} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {IncomingInvoice, IncomingInvoiceId} from "../../models/accounting/IncomingInvoice";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, switchMap} from "rxjs/operators";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {IncomingInvoiceModule} from "../../models/accounting/IncomingInvoice";
import {IProjectLogEntry} from "../../models/projects/ProjectLog";
import {Identifier} from "../../models/common/Identifier";

/** backend api path */
function apiPath( id: number ): string {
    const uri = 'invoices/incoming/'
    if( id === null ) {
        return APP_CONFIG.baseWeb + uri;
    } else {
        return APP_CONFIG.baseWeb + uri  + id + "/log";
    }
}


/** union of all Bill related action types */
export type IncomingInvoiceProjectLogViewActionTypes = FetchIncomingInvoicesProjectLogActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchIncomingInvoicesProjectLogAction extends IncomingInvoiceId, UserViewSettingsProp, ReduxAction< typeof FETCH_INCOMING_INVOICES_PROJECT_LOG > {}
export interface FetchIncomingInvoicesProjectLogSuccessAction extends IncomingInvoiceId, ReduxAction<typeof FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS > {
    payload: ApiReturnType< IProjectLogEntry[] >

}
export interface FetchIncomingInvoicesProjectLogErrorAction extends IncomingInvoiceId, ErrorAction< typeof FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR >{}

export type FetchIncomingInvoicesProjectLogActionTypes = FetchIncomingInvoicesProjectLogAction | FetchIncomingInvoicesProjectLogErrorAction | FetchIncomingInvoicesProjectLogSuccessAction

/**
 * redux action constants
 */
export const FETCH_INCOMING_INVOICES_PROJECT_LOG = "FETCH_INCOMING_INVOICES_PROJECT_LOG";
export const FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS = "FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS";
export const FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR = "FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR";

/**
 * redux action functions
 */
export function fetchIncomingInvoicesProjectLog(
    incomingInvoiceId: Identifier< number >,
    userViewSettings: UserViewSettings
) : FetchIncomingInvoicesProjectLogAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_LOG, userViewSettings, invoiceId: incomingInvoiceId };
}
export function fetchIncomingInvoicesProjectLogSuccess(
    incomingInvoiceId: Identifier< number >,
    payload: ApiReturnType< IProjectLogEntry[] >
) : FetchIncomingInvoicesProjectLogSuccessAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS, payload, invoiceId: incomingInvoiceId };
}
export function fetchIncomingInvoicesProjectLogError(
    incomingInvoiceId: Identifier<number>,
    error: Error
): FetchIncomingInvoicesProjectLogErrorAction {
    return { type: FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR, error, invoiceId: incomingInvoiceId };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchIncomingInvoicesProjectLogEpic(
    action$: Observable< FetchIncomingInvoicesProjectLogAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType(FETCH_INCOMING_INVOICES_PROJECT_LOG),
        switchMap(action => {
            const path = `${ apiPath( action.invoiceId.rawValue ) }${  getUrlParamsFromViewSettings( action.userViewSettings ) }`;

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => fetchIncomingInvoicesProjectLogSuccess(
                    action.invoiceId,
                    response.response as ApiReturnType< IProjectLogEntry[] >
                )),
                catchError(error => of(
                    fetchIncomingInvoicesProjectLogError( action.invoiceId, error),
                    eventNotificationError(error, store$, IncomingInvoiceModule.identifier, "fetchIncomingInvoicesProjectLog")
                ))
            );

        })
    );
}